module.exports = __webpack_public_path__ + "0350d4156b364dac5d4a185e37a06483.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/saaspass-users/user-labels/create-label/create-label.html
// module id = 2283
// module chunks = 0